module.exports = __webpack_public_path__ + "img/Rear_Addon.de65acf8.jpg";